import axios, { AxiosRequestConfig, CancelTokenSource, InternalAxiosRequestConfig } from 'axios';
import { authRequestInterceptor, authResponseErrorInterceptors, authResponseSuccessInterceptors } from '../interceptors/auth.interceptor';
import {
   cancelTokenRequestInterceptor,
   cancelTokenResponseErrorInterceptors,
   cancelTokenResponseSuccessInterceptors,
} from '../interceptors/cancel-token.interceptor';
import { errorResponseErrorInterceptor, errorResponseSuccessInterceptor } from '../interceptors/error.interceptor';
import { localizationRequestInterceptor } from '../interceptors/localization.interceptor';
import { versionResponseInterceptor } from '../interceptors/version.interceptor';

export interface CustomAxiosRequestConfig extends InternalAxiosRequestConfig {
   cancelable?: boolean;
}

const cancelTokenDict: { [request: string]: CancelTokenSource } = {};

function addCancelToken(request?: string, cancelToken?: CancelTokenSource) {
   if (!request || !cancelToken) return;
   cancelTokenDict[request] = cancelToken;
}
function removeCancelToken(request?: string) {
   if (!request) return;
   if (cancelTokenDict[request]) delete cancelTokenDict[request];
}

const baseConfig: AxiosRequestConfig = {
   baseURL: import.meta.env.VITE_APP_API_BASE_URL as string,
   maxBodyLength: 20 * 1024 * 1024, // 20MB
   maxContentLength: 20 * 1024 * 1024, // 20MB
   timeout: 30000, // 30 seconds,
};

const cacheFirstConfig: AxiosRequestConfig = {
   headers: {
      'Cache-Control': 'force-cache',
   },
};

const staleWhileRevalidateConfig: AxiosRequestConfig = {
   headers: {
      'Cache-Control': 'stale-while-revalidate',
   },
};

const http = axios.create(baseConfig);

//request interceptors
http.interceptors.request.use(authRequestInterceptor);
http.interceptors.request.use(localizationRequestInterceptor);
http.interceptors.request.use(cancelTokenRequestInterceptor);

//response interceptors
http.interceptors.response.use(authResponseSuccessInterceptors, authResponseErrorInterceptors);
http.interceptors.response.use(versionResponseInterceptor);
http.interceptors.response.use(errorResponseSuccessInterceptor, errorResponseErrorInterceptor);
http.interceptors.response.use(cancelTokenResponseSuccessInterceptors, cancelTokenResponseErrorInterceptors);

export { addCancelToken, cacheFirstConfig, cancelTokenDict, http, removeCancelToken, staleWhileRevalidateConfig };
